import useAuth from "../../../hooks/useAuth";
import {useState} from "react";
import {useParams} from "react-router-dom";
import {updateEventAddedInfos} from "../../../api/pro/eventReq";
import FormButtons from "../../../components/common/FormButtons";

export default function FormAddedInfos({ setShowModal, infos, apiEventAddedInfos }) {
    const { auth } = useAuth();
    const token = auth?.token;
    const { id } = useParams();
    const [ infosData, setInfosData ] = useState();

    const handleSubmit = (e) => {
        e.preventDefault();
        let body =  {
            deceasedId: id,
            addedInfos: infosData
        }
        updateEventAddedInfos(token, body)
            .then((response) => {
                if (response?.response?.data?.error) {
                    console.log(response?.response?.data?.error)
                } else {
                    setShowModal(false)
                    apiEventAddedInfos()
                }
            })
    }

    const handleChange = (e) => {
        setInfosData(e.target.value)
    }

    const handleRemoveModal = (e) => {
        setShowModal(false)
    }

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                <div className="form-input html-textarea">
                    <label htmlFor="infos">Précisions complémentaires :</label>
                    <textarea 
                        name="infos" 
                        className="addedinfos-textarea"
                        defaultValue={infos} 
                        placeholder="Exemple : Pas de fleurs, ni plaques."
                        onChange={handleChange}
                    />
                </div>
                <FormButtons handleRemoveModal={handleRemoveModal}/>
            </fieldset>
        </form>
    )
}